import React from "react";
import { observer } from "mobx-react";
import { QueryPatternCreateStore } from "../../store";
import { QueryPatternCreateForm } from "./QueryPatternCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { EvaluationPathType } from "../../../../api/graphql";
import { QueryPatternSource } from "../../../../api/graphql";

export type QueryPatternCreateProps = {
  queryPatternCreateStore: QueryPatternCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const QueryPatternCreate: React.FC<QueryPatternCreateProps> = observer(
  ({ queryPatternCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={queryPatternCreateStore.isSaving} />
        <QueryPatternCreateForm
          queryPatternCreateStore={queryPatternCreateStore}
          nameError={queryPatternCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            queryPatternCreateStore.setNameValue(value);
          }}
          name={queryPatternCreateStore.entityValues.name}
          patternError={queryPatternCreateStore.errors.pattern?.message}
          onPatternChange={(value: string) => {
            queryPatternCreateStore.setPatternValue(value);
          }}
          pattern={queryPatternCreateStore.entityValues.pattern}
          pathTypeError={queryPatternCreateStore.errors.pathType?.message}
          pathTypeOptions={queryPatternCreateStore.getPathTypeOptions()}
          onPathTypeChange={(value: EvaluationPathType) => {
            queryPatternCreateStore.setPathTypeValue(value);
          }}
          pathType={queryPatternCreateStore.entityValues.pathType}
          variablesError={queryPatternCreateStore.errors.variables?.message}
          onVariablesChange={(value: string) => {
            queryPatternCreateStore.setVariablesValue(value);
          }}
          variables={queryPatternCreateStore.entityValues.variables}
          toolTemplateError={
            queryPatternCreateStore.errors.toolTemplate?.message
          }
          onToolTemplateChange={(value: string) => {
            queryPatternCreateStore.setToolTemplateValue(value);
          }}
          toolTemplate={queryPatternCreateStore.entityValues.toolTemplate}
          argsTemplateError={
            queryPatternCreateStore.errors.argsTemplate?.message
          }
          onArgsTemplateChange={(value: string) => {
            queryPatternCreateStore.setArgsTemplateValue(value);
          }}
          argsTemplate={queryPatternCreateStore.entityValues.argsTemplate}
          variationsError={queryPatternCreateStore.errors.variations?.message}
          onVariationsChange={(value: string) => {
            queryPatternCreateStore.setVariationsValue(value);
          }}
          variations={queryPatternCreateStore.entityValues.variations}
          exampleInstantiationError={
            queryPatternCreateStore.errors.exampleInstantiation?.message
          }
          onExampleInstantiationChange={(value: string) => {
            queryPatternCreateStore.setExampleInstantiationValue(value);
          }}
          exampleInstantiation={
            queryPatternCreateStore.entityValues.exampleInstantiation
          }
          sourceError={queryPatternCreateStore.errors.source?.message}
          sourceOptions={queryPatternCreateStore.getSourceOptions()}
          onSourceChange={(value: QueryPatternSource) => {
            queryPatternCreateStore.setSourceValue(value);
          }}
          source={queryPatternCreateStore.entityValues.source}
          qualityScoreError={
            queryPatternCreateStore.errors.qualityScore?.message
          }
          onQualityScoreChange={(value: number) => {
            queryPatternCreateStore.setQualityScoreValue(value);
          }}
          qualityScore={queryPatternCreateStore.entityValues.qualityScore}
          usageCountError={queryPatternCreateStore.errors.usageCount?.message}
          onUsageCountChange={(value: number) => {
            queryPatternCreateStore.setUsageCountValue(value);
          }}
          usageCount={queryPatternCreateStore.entityValues.usageCount}
          isActiveError={queryPatternCreateStore.errors.isActive?.message}
          onIsActiveChange={(value: boolean) => {
            queryPatternCreateStore.setIsActiveValue(value);
          }}
          isActive={queryPatternCreateStore.entityValues.isActive}
          notesError={queryPatternCreateStore.errors.notes?.message}
          onNotesChange={(value: string) => {
            queryPatternCreateStore.setNotesValue(value);
          }}
          notes={queryPatternCreateStore.entityValues.notes}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={queryPatternCreateStore.isProcessing}
          onSave={() => queryPatternCreateStore.saveNewQueryPattern()}
          onCancel={() => queryPatternCreateStore.cancelNewQueryPattern()}
        />
        <ErrorDialog
          open={queryPatternCreateStore.errorDialogOpened}
          title={queryPatternCreateStore.errorTitle}
          description={queryPatternCreateStore.errorDescription}
          onClose={() => queryPatternCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
